import * as types from './actionTypes'

export const initialState = {
  profileToPost: {},
  fetchedLoadProfiles: {},
  transporterInfo: {},
  requirements: [],
  certificates: [],
  configs: [],
  operationGroups: null,
}

const formatConfigs = (list = []) => {
  const result = list.reduce((acc, item) => {
    acc[item.name] = {
      id: item.id,
      value: item.value,
      description: item.description,
      visibility: item.visibility,
      transporterId: item.transporterId,
      name: item.name,
    }
    return acc
  }, {})

  return result
}

const Settings = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LIST_ALL_CONTACTS:
      return {
        ...state,
        contacts: payload,
      }
    case types.FETCH_OPERATION_GROUPS:
      return {
        ...state,
        operationGroups: payload,
      }
    case types.SAVE_TRANSPORTER_CONFIGS: {
      return {
        ...state,
        configs: formatConfigs(payload),
      }
    }
    case types.FETCH_TRANSPORTER_INFO:
      return { ...state, transporterInfo: { ...state.transporterInfo, ...payload } }
    case types.UPDATE_TRANSPORTER_INFO:
      return { ...state, transporterInfo: payload }
    case types.FETCH_AVAILABLE_PROPERTIES:
      return { ...state, requirements: payload }
    case types.FETCH_AVAILABLE_CERTIFICATES:
      return { ...state, certificates: payload }
    case types.FETCH_LOAD_PROFILE_BY_ID:
      return {
        ...state,
        fetchedLoadProfiles: { ...state.fetchedLoadProfiles, [payload.id]: payload.data },
      }
    case types.FETCH_CERTIFICATIONS_IMAGES:
      return {
        ...state,
        transporterInfo: {
          ...state.transporterInfo,
          certifications: [...payload],
        },
      }
    case types.UPDATE_CERTIFICATES_ON_STATE:
      return {
        ...state,
        transporterInfo: {
          ...state.transporterInfo,
          certifications: [...payload],
        },
      }
    default:
      return state
  }
}

export default Settings
